import { createContext, useContext } from "react";

export const LanguageContext = createContext({ lang: "es", setLang: () => {}, t: {} });
export const useLang = () => useContext(LanguageContext);

export const PAYMENT_URL = "https://pay.sumup.com/b2c/QXAJB8AP";
export const INSTAGRAM_URL = "https://www.instagram.com/oficialkhouse";
export const EMAIL = "oficialkhouse@gmail.com";
export const ADDRESS = "C. Juan Rumeu García, 8, 38008 Santa Cruz de Tenerife";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -76 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const GROUP_OPTIONS = [
  "K-Kids · San Jerónimo",
  "K1.0 · Cruz del Señor",
  "K1 · Cruz del Señor",
  "K2 · Cruz del Señor",
];

export const WHATSAPP = {
  familias: [
    { code: "K-Kids", url: "https://chat.whatsapp.com/EeUerUolrjPGTLKmjIlP0H" },
    { code: "K1.0", url: "https://chat.whatsapp.com/GNuXQMDffbQ3rdhKJa4Kvw" },
    { code: "K1", url: "https://chat.whatsapp.com/GiyWNpgud7kCCVHanCrKX7" },
    { code: "K2", url: "https://chat.whatsapp.com/FpwX97Ek8Ef6RY75yh9LfB" },
  ],
  alumnado: [
    { code: "K1.0", url: "https://chat.whatsapp.com/Kr7LovZDFgxBApPAwDM9mi" },
    { code: "K1", url: "https://chat.whatsapp.com/ItzcVlMVLXLLAf90xGCwzr" },
    { code: "K2", url: "https://chat.whatsapp.com/KPaYveKPLI35rHjW0Xn8h2" },
    { code: "K3", url: "https://chat.whatsapp.com/IcG2tMwG4fVJwZ6nluG0Bt" },
  ],
  general: [],
};

export const SEDES = [
  { id: "san-jeronimo", name: "Sede San Jerónimo", addr: "Centro Ciudadano San Jerónimo", maps: "https://www.google.com/maps/search/?api=1&query=Centro+Ciudadano+San+Jer%C3%B3nimo+Santa+Cruz+de+Tenerife" },
  { id: "cruz-del-senor", name: "Sede Cruz del Señor", addr: "Local K-house · C. Juan Rumeu García, 8", maps: "https://www.google.com/maps/search/?api=1&query=C.+Juan+Rumeu+Garc%C3%ADa+8,+38008+Santa+Cruz+de+Tenerife" },
];

// Horarios vigentes. K1.0 y K1 no son niveles: son grupos para disfrutar el K-POP.
// K3 cerrado temporalmente: en la web pública se muestra su estado,
// nunca su horario antiguo como vigente.
export const GROUPS = [
  { code: "K-Kids", sede: 0, days: ["lun", "jue"], time: "17:00 – 19:00", level: "infantil", status: "open" },
  { code: "K3", sede: 0, days: [], time: "18:30 – 20:30", level: "adultos", status: "closed", reopening: "Enero 2027" },
  { code: "K1.0", sede: 1, days: ["lun", "jue"], time: "16:30 – 18:30", status: "open" },
  { code: "K1", sede: 1, days: ["mar", "vie"], time: "16:00 – 18:00", status: "open" },
  { code: "K2", sede: 1, days: ["mar", "vie"], time: "18:00 – 20:00", level: "avanzado", status: "full" },
];

// Galería editorial — solo fotografías reales de K-HOUSE
export const GALLERY = [
  { url: "/photos/escenario_01.webp", cat: "escenario", span: "sm:col-span-2 sm:row-span-2", alt: "K-HOUSE · coreografía de grupo en el escenario" },
  { url: "/photos/p11.webp", cat: "eventos", span: "sm:col-span-2 sm:row-span-2", alt: "K-HOUSE · TecnoCon ELITE K-POP CONTEST" },
  { url: "/photos/escenario_03.webp", cat: "comunidad", span: "sm:col-span-2 sm:row-span-1", alt: "K-HOUSE · alegría y comunidad tras la actuación" },
  { url: "/photos/p26.webp", cat: "eventos", span: "sm:col-span-2 sm:row-span-2", alt: "K-HOUSE · actuación en el ELITE K-POP CONTEST" },
  { url: "/photos/escenario_04.webp", cat: "escenario", span: "sm:col-span-1 sm:row-span-1", alt: "K-HOUSE · bailarina en solitario bajo las luces" },
  { url: "/photos/p05.webp", cat: "escenario", span: "sm:col-span-2 sm:row-span-2", alt: "K-HOUSE · puesta en escena teatral" },
  { url: "/photos/escenario_05.webp", cat: "escenario", span: "sm:col-span-1 sm:row-span-2", alt: "K-HOUSE · energía en escena" },
  { url: "/photos/p27.webp", cat: "eventos", span: "sm:col-span-2 sm:row-span-2", alt: "K-HOUSE · ELITE K-POP CONTEST" },
  { url: "/photos/escenario_02.webp", cat: "escenario", span: "sm:col-span-2 sm:row-span-1", alt: "K-HOUSE · dúo coreográfico" },
  { url: "/photos/p29.webp", cat: "eventos", span: "sm:col-span-1 sm:row-span-1", alt: "K-HOUSE · trío en competición" },
  { url: "/photos/p44.webp", cat: "escenario", span: "sm:col-span-2 sm:row-span-2", alt: "K-HOUSE · grupo en plena actuación" },
  { url: "/photos/p48.webp", cat: "eventos", span: "sm:col-span-4 sm:row-span-2", alt: "K-HOUSE · cierre de gala con todo el elenco" },
  { url: "/photos/escenario_06.jpg", cat: "escenario", span: "sm:col-span-2 sm:row-span-2", alt: "K-HOUSE · K-Kids en escena con el logo de la academia" },
  { url: "/photos/escenario_07.jpg", cat: "escenario", span: "sm:col-span-2 sm:row-span-2", alt: "K-HOUSE · grupo con diseños plateados en escena" },
  { url: "/photos/escenario_08.jpg", cat: "escenario", span: "sm:col-span-2 sm:row-span-1", alt: "K-HOUSE · dúo en el escenario" },
  { url: "/photos/clase_01.webp", cat: "clases", span: "sm:col-span-2 sm:row-span-1", alt: "K-HOUSE · alumnas disfrutando en clase" },
  { url: "/photos/clase_02.webp", cat: "clases", span: "sm:col-span-2 sm:row-span-1", alt: "K-HOUSE · ensayo en el estudio" },
  { url: "/photos/tlp_4.webp", cat: "eventos", span: "sm:col-span-4 sm:row-span-2", alt: "K-HOUSE · gran escenario en el TLP" },
  { url: "/photos/tlp_5.webp", cat: "eventos", span: "sm:col-span-2 sm:row-span-1", alt: "K-HOUSE · actuación en el TLP" },
  { url: "/photos/tlp_2.webp", cat: "eventos", span: "sm:col-span-1 sm:row-span-1", alt: "K-HOUSE · baile en el escenario del TLP" },
  { url: "/photos/tlp_3.webp", cat: "eventos", span: "sm:col-span-2 sm:row-span-1", alt: "K-HOUSE · coreografía con confeti en el TLP" },
  { url: "/photos/tlp_1.webp", cat: "eventos", span: "sm:col-span-2 sm:row-span-1", alt: "K-HOUSE · coreografía de suelo en el TLP" },
  { url: "/photos/campamento_05.jpg", cat: "comunidad", span: "sm:col-span-2 sm:row-span-1", alt: "K-HOUSE · clase de baile K-POP en el campamento" },
  { url: "/photos/campamento_04.jpg", cat: "comunidad", span: "sm:col-span-1 sm:row-span-1", alt: "K-HOUSE · amigas en el campamento" },
  { url: "/photos/campamento_03.jpg", cat: "comunidad", span: "sm:col-span-2 sm:row-span-1", alt: "K-HOUSE · taller de maquillaje asiático en el campamento" },
  { url: "/photos/campamento_02.jpg", cat: "comunidad", span: "sm:col-span-1 sm:row-span-1", alt: "K-HOUSE · risas en el campamento" },
  { url: "/photos/campamento_01.jpg", cat: "comunidad", span: "sm:col-span-2 sm:row-span-1", alt: "K-HOUSE · descanso en el campamento" },
];

export const EVENTS_MEDIA = {
  aniversario: "/photos/p26.webp",
  campamentos: "/photos/campamento_03.jpg",
  navidad: "/photos/p05.webp",
  workshops: "/images/jay-kim.jpg",
};

const groups = {
  kkids: { key: "K-Kids", photo: "/photos/grupo_kkids.jpg" },
  k1_0: { key: "K1.0", photo: "/photos/grupo_k10.jpg" },
  k1: { key: "K1", photo: "/photos/grupo_k1.jpg" },
  k2: { key: "K2", photo: "/photos/p44.webp" },
  k3: { key: "K3" },
};
export const GROUP_CARDS = groups;

export const dict = {
  es: {
    nav: {
      links: [
        { id: "inicio", label: "Inicio" },
        { id: "academia", label: "Academia" },
        { id: "grupos", label: "Grupos" },
        { id: "horarios", label: "Horarios" },
        { id: "competicion", label: "Competición" },
        { id: "galeria", label: "Galería" },
        { id: "eventos", label: "Eventos" },
        { id: "contacto", label: "Contacto" },
      ],
      cta: "Matrícula",
      acceso: "Acceso",
    },
    hero: {
      titleA: "K-HOUSE",
      titleB: "DANCE ACADEMY",
      tagline: "WE DON'T JUST DANCE. WE ARE K-HOUSE.",
      tag: "K-POP · DANCE · COMMUNITY",
      ctaKnow: "Conócenos",
      ctaEnroll: "Inscripciones",
      scroll: "Desliza",
      status: "Matrícula abierta",
      badge: "Curso 2026/2027",
    },
    marquee: ["K-HOUSE DANCE ACADEMY", "SANTA CRUZ DE TENERIFE", "WE ARE K-HOUSE", "K-POP · DANCE · COMMUNITY"],
    wkBanner: {
      badge: "Evento especial · Special Guest",
      title: "SPECIAL K-POP DANCE WORKSHOP",
      feat: "FEATURING JAY KIM",
      desc: "Antiguo profesor de la prestigiosa academia 1MILLION y coreógrafo de artistas como Jay Park y THE BOYZ.",
      date: "21 · NOV · 2026",
      single: "Single 20€",
      full: "Full Experience 35€",
      cta: "Reserva tu plaza",
      photoAlt: "JAY KIM, artista invitado del Special K-Pop Dance Workshop",
    },
    presentation: {
      label: "La academia",
      title: "Esto es K-HOUSE",
      intro: "K-HOUSE es una asociación juvenil dedicada a promover la cultura coreana y el K-POP a través de la danza, la formación y las actividades culturales.",
      blocks: [
        { key: "pasion", n: "01", t: "Pasión", d: "Vivimos el K-POP y compartimos nuestra pasión por la danza." },
        { key: "disciplina", n: "02", t: "Disciplina", d: "Trabajamos cada día para mejorar nuestra técnica, coordinación y expresión artística." },
        { key: "comunidad", n: "03", t: "Comunidad", d: "Somos mucho más que una academia. Somos una comunidad que crece, aprende y disfruta unida." },
      ],
    },
    groups: {
      label: "Nuestros grupos",
      title: "Elige tu grupo",
      subtitle: "Cinco grupos, dos sedes, una misma comunidad.",
      daysLabel: { lun: "Lunes", mar: "Martes", jue: "Jueves", vie: "Viernes" },
      join: "y",
      scheduleLabel: "Horario",
      sedeLabel: "Sede",
      openBadge: "Inscripciones abiertas",
      fullBadge: "Plazas cerradas",
      cta: "Quiero inscribirme",
      cards: {
        kkids: { d: "Un espacio para que los más pequeños descubran el baile, desarrollen su coordinación, aprendan coreografías y disfruten del K-POP." },
        k1_0: { d: "Un espacio para aprender desde cero, conocer coreografías y disfrutar de la danza sin necesidad de experiencia previa." },
        k1: { d: "Orientado al aprendizaje coreográfico, mejora de técnica y disfrute de la danza." },
        k2: { d: "Un espacio para bailarines que desean seguir mejorando su técnica, precisión, presencia y rendimiento." },
        k3: { d: "Grupo dirigido a personas adultas amantes del K-POP." },
      },
      k3: {
        badge: "Cerrado temporalmente",
        title: "K3 — SEE YOU IN JANUARY!",
        note: "Cerrado temporalmente. Actualmente no hay inscripciones abiertas para este grupo.",
        reopening: "Prevista reapertura: enero 2027",
        cta: "Quiero información sobre la reapertura",
        phName: "Tu nombre",
        phEmail: "Tu correo electrónico",
        send: "Avisadme",
        sending: "Enviando…",
        ok: "¡Apuntado! Te avisaremos cuando abramos las inscripciones de K3.",
        err: "Ups, algo salió mal. Inténtalo de nuevo.",
      },
    },
    schedule: {
      label: "Horarios & ubicaciones",
      title: "Sedes & Horarios",
      subtitle: "Dos sedes en Santa Cruz de Tenerife. Elige tu grupo y ven a bailar.",
      days: { lun: "Lunes", mar: "Martes", jue: "Jueves", vie: "Viernes" },
      join: "y",
      howTo: "Cómo llegar",
      k3Closed: "Cerrado temporalmente · Reapertura enero 2027",
    },
    competition: {
      label: "K-House on stage",
      title: "Grupos de Competición",
      desc: "K-HOUSE sube a los grandes escenarios para disfrutar del escenario y de la experiencia: ELITE K-POP CONTEST, TLP y K-POP World Festival.",
      chips: ["ELITE K-POP CONTEST", "TLP Tenerife", "K-POP WORLD FESTIVAL"],
      photoAlt: "K-HOUSE · grupo en el escenario del TLP",
    },
    gallery: {
      label: "Galería",
      title: "K-POP en escena",
      filters: { todos: "Todos", escenario: "Escenario", eventos: "Eventos", clases: "Clases", comunidad: "Comunidad" },
      close: "Cerrar",
    },
    events: {
      label: "Eventos & actividades",
      title: "Siempre en movimiento",
      subtitle: "Actuaciones, campamentos, workshops y tradiciones propias de nuestra comunidad.",
      items: [
        { key: "aniversario", t: "Aniversario K-HOUSE", d: "Celebramos cada año nuestra historia con toda la familia." },
        { key: "campamentos", t: "Campamentos", d: "Semana Santa de cultura coreana: coreano, cocina y maquillaje asiático + K-POP. Verano: multideporte." },
        { key: "navidad", t: "Navidad", d: "Gala navideña y momentos especiales de fin de año." },
        { key: "workshops", t: "Workshops", d: "Bailarines invitados como JAY KIM vienen a K-HOUSE." },
      ],
    },
    whatsapp: {
      label: "Nuestra comunidad",
      title: "K-HOUSE en WhatsApp",
      subtitle: "Entra en tu canal: avisos, ensayos y novedades al instante.",
      familias: "Familias",
      familiasSub: "Padres, madres y tutores legales",
      alumnado: "Alumnado",
      alumnadoSub: "Bailarines K-house",
      general: "Información general",
      generalSub: "Consultas, horarios y novedades",
      generalCta: "Escríbenos",
      join: "Unirse",
      note: "Entra únicamente en el canal correspondiente a tu grupo.",
    },
    tuition: {
      label: "Cuotas & socios",
      title: "Cuota & Pagos Online",
      price: "20€",
      per: "/mes",
      desc: "El pago de la cuota mensual de 20€ debe realizarse obligatoriamente dentro de los primeros 10 días naturales de cada mes.",
      window: "Del 1 al 10 de cada mes",
      windowNote: "días naturales",
      button: "Pagar Cuota Mensual",
      secure: "Pasarela segura · SumUp",
      includesTitle: "Qué incluye",
      includes: ["Clases semanales de tu grupo", "Preparación de actuaciones", "Participación en la comunidad K-HOUSE"],
      types: [
        { t: "Cuota de socio", d: "20€ / mes · pago online con SumUp" },
        { t: "Actividades especiales", d: "Pago puntual según actividad" },
        { t: "Inscripciones a workshops", d: "Inscripción propia (p. ej. JAY KIM)" },
      ],
    },
    contact: {
      label: "Inscripciones & contacto",
      title: "¿QUIERES FORMAR PARTE DE K-HOUSE?",
      join: "JOIN OUR FAMILY.",
      subtitle: "Rellena el formulario y te respondemos lo antes posible.",
      student: "Nombre del alumno/a",
      guardian: "Padre/Madre/Tutor (si es menor)",
      phone: "Teléfono (WhatsApp)",
      email: "Correo electrónico",
      group: "Grupo deseado",
      groupPlaceholder: "Selecciona un grupo",
      comments: "Comentarios o dudas",
      commentsPlaceholder: "Cuéntanos algo sobre ti…",
      submit: "Enviar inscripción",
      sending: "Enviando…",
      success: "¡Inscripción recibida! Te contactaremos muy pronto.",
      error: "Ups, algo salió mal. Inténtalo de nuevo o escríbenos por Instagram.",
      igLabel: "Instagram",
      emailLabel: "Escríbenos",
      newInquiry: "Consultas nuevas y matrícula",
      addrLabel: "Dirección",
    },
    footer: {
      tagline: "Asociación Juvenil de Baile K-house · Impulsando la cultura K-POP y el baile en Tenerife.",
      rights: "K-house Dance Academy · Asociación Juvenil de Baile K-house",
      menu: "Menú",
      follow: "Síguenos",
      legal: "Legal",
      contact: "Contacto",
      legalLinks: [
        { id: "aviso", label: "Aviso legal" },
        { id: "privacidad", label: "Política de privacidad" },
        { id: "condiciones", label: "Condiciones de uso" },
      ],
    },
  },
  en: {
    nav: {
      links: [
        { id: "inicio", label: "Home" },
        { id: "academia", label: "Academy" },
        { id: "grupos", label: "Groups" },
        { id: "horarios", label: "Schedule" },
        { id: "competicion", label: "Competition" },
        { id: "galeria", label: "Gallery" },
        { id: "eventos", label: "Events" },
        { id: "contacto", label: "Contact" },
      ],
      cta: "Enroll",
      acceso: "Students",
    },
    hero: {
      titleA: "K-HOUSE",
      titleB: "DANCE ACADEMY",
      tagline: "WE DON'T JUST DANCE. WE ARE K-HOUSE.",
      tag: "K-POP · DANCE · COMMUNITY",
      ctaKnow: "Know us",
      ctaEnroll: "Enrollment",
      scroll: "Scroll",
      status: "Enrollment open",
      badge: "Academic Year 2026/2027",
    },
    marquee: ["K-HOUSE DANCE ACADEMY", "SANTA CRUZ DE TENERIFE", "WE ARE K-HOUSE", "K-POP · DANCE · COMMUNITY"],
    wkBanner: {
      badge: "Special event · Special Guest",
      title: "SPECIAL K-POP DANCE WORKSHOP",
      feat: "FEATURING JAY KIM",
      desc: "Former teacher at the prestigious 1MILLION studio and choreographer for artists like Jay Park and THE BOYZ.",
      date: "21 · NOV · 2026",
      single: "Single €20",
      full: "Full Experience €35",
      cta: "Book your spot",
      photoAlt: "JAY KIM, guest artist of the Special K-Pop Dance Workshop",
    },
    presentation: {
      label: "The academy",
      title: "This is K-HOUSE",
      intro: "K-HOUSE is a youth association dedicated to promoting Korean culture and K-POP through dance, training and cultural activities.",
      blocks: [
        { key: "pasion", n: "01", t: "Passion", d: "We live K-POP and share our passion for dance." },
        { key: "disciplina", n: "02", t: "Discipline", d: "We work every day to improve our technique, coordination and artistic expression." },
        { key: "comunidad", n: "03", t: "Community", d: "We are much more than an academy. We are a community that grows, learns and enjoys together." },
      ],
    },
    groups: {
      label: "Our groups",
      title: "Choose your group",
      subtitle: "Five groups, two locations, one community.",
      daysLabel: { lun: "Monday", mar: "Tuesday", jue: "Thursday", vie: "Friday" },
      join: "and",
      scheduleLabel: "Schedule",
      sedeLabel: "Location",
      openBadge: "Enrollment open",
      fullBadge: "Spots closed",
      cta: "I want to enroll",
      cards: {
        kkids: { d: "A space for the youngest to discover dance, develop coordination, learn choreographies and enjoy K-POP." },
        k1_0: { d: "A space to learn from scratch, get to know choreographies and enjoy dance with no previous experience needed." },
        k1: { d: "Focused on choreographic learning, technique improvement and the joy of dance." },
        k2: { d: "A space for dancers who want to keep improving their technique, precision, presence and performance." },
        k3: { d: "Group for adults who love K-POP." },
      },
      k3: {
        badge: "Temporarily closed",
        title: "K3 — SEE YOU IN JANUARY!",
        note: "Temporarily closed. There are currently no open enrollments for this group.",
        reopening: "Expected reopening: January 2027",
        cta: "I want info about the reopening",
        phName: "Your name",
        phEmail: "Your email",
        send: "Notify me",
        sending: "Sending…",
        ok: "You're in! We'll let you know when K3 enrollment opens.",
        err: "Oops, something went wrong. Please try again.",
      },
    },
    schedule: {
      label: "Schedules & locations",
      title: "Locations & Schedule",
      subtitle: "Two locations in Santa Cruz de Tenerife. Pick your group and come dance.",
      days: { lun: "Monday", mar: "Tuesday", jue: "Thursday", vie: "Friday" },
      join: "and",
      howTo: "How to get there",
      k3Closed: "Temporarily closed · Reopening January 2027",
    },
    competition: {
      label: "K-House on stage",
      title: "Competition Groups",
      desc: "K-HOUSE takes the big stages to enjoy the stage and the experience: ELITE K-POP CONTEST, TLP and K-POP World Festival.",
      chips: ["ELITE K-POP CONTEST", "TLP Tenerife", "K-POP WORLD FESTIVAL"],
      photoAlt: "K-HOUSE · group on the TLP stage",
    },
    gallery: {
      label: "Gallery",
      title: "K-POP on stage",
      filters: { todos: "All", escenario: "Stage", eventos: "Events", clases: "Classes", comunidad: "Community" },
      close: "Close",
    },
    events: {
      label: "Events & activities",
      title: "Always in motion",
      subtitle: "Performances, camps, workshops and our own community traditions.",
      items: [
        { key: "aniversario", t: "K-HOUSE Anniversary", d: "We celebrate our history every year with the whole family." },
        { key: "campamentos", t: "Camps", d: "Easter camp of Korean culture: Korean, cooking and Asian makeup workshops + K-POP. Summer: multisports." },
        { key: "navidad", t: "Christmas", d: "Christmas gala and special end-of-year moments." },
        { key: "workshops", t: "Workshops", d: "Guest dancers like JAY KIM come to K-HOUSE." },
      ],
    },
    whatsapp: {
      label: "Our community",
      title: "K-HOUSE on WhatsApp",
      subtitle: "Join your channel: notices, rehearsals and updates instantly.",
      familias: "Families",
      familiasSub: "Parents and legal guardians",
      alumnado: "Students",
      alumnadoSub: "K-house dancers",
      general: "General information",
      generalSub: "Questions, schedules and news",
      generalCta: "Contact us",
      join: "Join",
      note: "Only join the channel that matches your group.",
    },
    tuition: {
      label: "Tuition & members",
      title: "Tuition & Online Payments",
      price: "€20",
      per: "/month",
      desc: "The monthly tuition of 20€ must be paid within the first 10 calendar days of each month.",
      window: "From the 1st to the 10th each month",
      windowNote: "calendar days",
      button: "Pay Monthly Tuition",
      secure: "Secure gateway · SumUp",
      includesTitle: "What's included",
      includes: ["Weekly classes for your group", "Performance preparation", "Being part of the K-HOUSE community"],
      types: [
        { t: "Member tuition", d: "€20 / month · online via SumUp" },
        { t: "Special activities", d: "One-off payment per activity" },
        { t: "Workshop enrollments", d: "Separate signup (e.g. JAY KIM)" },
      ],
    },
    contact: {
      label: "Enrollment & contact",
      title: "WANT TO JOIN K-HOUSE?",
      join: "JOIN OUR FAMILY.",
      subtitle: "Fill in the form and we will get back to you as soon as possible.",
      student: "Student's full name",
      guardian: "Parent/Guardian (if minor)",
      phone: "Phone (WhatsApp)",
      email: "Email address",
      group: "Desired group",
      groupPlaceholder: "Select a group",
      comments: "Comments or questions",
      commentsPlaceholder: "Tell us a bit about you…",
      submit: "Send registration",
      sending: "Sending…",
      success: "Registration received! We will contact you very soon.",
      error: "Oops, something went wrong. Try again or reach us on Instagram.",
      igLabel: "Instagram",
      emailLabel: "Write to us",
      newInquiry: "New inquiries & registration",
      addrLabel: "Address",
    },
    footer: {
      tagline: "K-house Youth Dance Association · Promoting K-POP culture and dance in Tenerife.",
      rights: "K-house Dance Academy · K-house Youth Dance Association",
      menu: "Menu",
      follow: "Follow us",
      legal: "Legal",
      contact: "Contact",
      legalLinks: [
        { id: "aviso", label: "Legal notice" },
        { id: "privacidad", label: "Privacy policy" },
        { id: "condiciones", label: "Terms of use" },
      ],
    },
  },
};